"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _excluded = ["hasFooter"];
var body = function body(_ref) {
  var hasFooter = _ref.hasFooter,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return {
    overflowY: 'auto',
    padding: 6,
    paddingBottom: hasFooter ? 24 : 6
  };
};
var footer = function footer(props) {
  return {
    padding: 6,
    backgroundColor: 'white',
    position: 'absolute',
    bottom: 0,
    width: '100%'
  };
};
var header = function header(props) {
  return {
    paddingY: 3,
    paddingX: 6,
    borderBottom: '1px solid',
    borderBottomColor: 'gray.100',
    display: 'flex',
    gridGap: 2,
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 'semibold'
  };
};
var closeButton = function closeButton(props) {
  return {
    width: 8,
    height: 8,
    fontSize: 'xs',
    background: 'transparent',
    borderRadius: 'md',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transitionProperty: 'common',
    transitionDuration: 'normal',
    outline: 'transparent solid 2px',
    outlineOffset: '2px',
    color: 'gray.600',
    _hover: {
      color: 'black',
      background: 'gray.100'
    },
    _focus: {
      outlineColor: 'primary.default'
    }
  };
};
var dialogContainer = function dialogContainer(props) {
  return {
    zIndex: 'layer2',
    backgroundColor: 'transparent'
  };
};
var dialog = function dialog(props) {
  return {
    backgroundColor: 'white',
    boxShadow: 'drawer'
  };
};
var baseStyle = function baseStyle(props) {
  return {
    body: body(props),
    footer: footer(props),
    header: header(props),
    dialog: dialog(props),
    closeButton: closeButton(props),
    dialogContainer: dialogContainer(props)
  };
};
var defaultProps = {
  size: 'xs'
};
var sizes = {
  xs: {
    dialog: {
      maxWidth: {
        base: '100vw',
        mobileXL: 80
      }
    }
  }
};
var _default = exports["default"] = (0, _merge["default"])(_theme["default"].components.Drawer, {
  defaultProps: defaultProps,
  baseStyle: baseStyle,
  sizes: sizes
});